import UserLayout from "../components/UserLayout";
import Gallery from "../components/Gallery";
const GalleryPage = () => {
    return (
        <UserLayout>
            <Gallery />
        </UserLayout>
    );
}

export default GalleryPage;